import { Component } from "@angular/core";
import { BranchFormComponent } from "../branch-form/branch-form.component";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { RowAccessComponent } from "../../row-access/row-access.component";
import { Branch, EntityListAction, Permission } from "projects/sepidz-web-framework/src/lib/models";
import { GridFilter, LookupService } from "projects/sepidz-web-framework/src/lib/services";
import { RowAccessKind } from "projects/sepidz-web-framework/src/lib/models/enums";
import { takeUntil } from "rxjs/operators";
import { MisSetupService } from "projects/sepidz-web-framework/src/lib/services/missetup.service";

@Component({
  selector: "ngx-branch-list",
  templateUrl: "./branch-list.component.html",
  styleUrls: ["./branch-list.component.scss"],
})
export class BranchListComponent extends BaseListComponent {
  target: any;
  isAdd: boolean = true;
  isEdit: boolean = true;
  isDelete: boolean = true;
  HasRowAccess: boolean;
  constructor(private lookupservice: LookupService, private missetup: MisSetupService) {
    super();
    this.inputEditorform = BranchFormComponent;
    this.onActionClick = this.onActionClick.bind(this);
  }
  ngOnInit() {
    if (this.HasRowAccess === undefined) {
      this.HasRowAccess = this.missetup.getboolean("GNR", "HasRowAccess");
    }
    this.target = () => import("src/app/gnr/branch/branch.module").then((m) => m.BranchModule);
    this.apiName = "Branch";
    this.areaName = "General";
    this.label = this.translate("ClientApp.GNR.Branch.BranchDefine");
    this.FillData();
    this.setactions();
  }
  async FillData() {
    const currentBranch = this.accountService.authService.currentInformation();
    if (
      currentBranch.RestaurantLightWeb ||
      (currentBranch.SepidzWebKind &&
        !currentBranch.RestaurantCallCenter &&
        !currentBranch.BranchingLightEnabled &&
        !currentBranch.BranchingAdvancedEnabled)
    ) {
      this.isAdd = false;
      this.isDelete = false;
    }
    if (currentBranch.RestaurantCallCenter) {
      if (!this.accountService.authService.currentBranch.AccessToAllBranches) {
        this.isAdd = false;
        this.isEdit = false;
        this.isDelete = false;
      }
    }
  }
  setactions() {
    if (this.HasRowAccess === true)
      this.actions = [
        {
          name: "RowAccess",
          disabled: false,
          displayName: this.translate("ClientApp.GNR.Branch.AccessInRows"),
          iconName: "icon-users",
          apiName: "Branch/RowAccess",
          areaName: "General",
          requireSelectedrows: true,
          Form_Component: RowAccessComponent,
          permission: Permission.samePermission,
        },
      ];
  }
  onActionClick(action: EntityListAction, onRowSelected: Branch, onRowsSelected: Branch[], isAllSelected: boolean, gridFilter: GridFilter[]) {
    if (action.name === "RowAccess") {
      let ids: number[] = [];
      if (onRowsSelected != null && onRowsSelected.length > 0) {
        onRowsSelected.forEach((x) => ids.push(x.Id));
      } else ids.push(onRowSelected.Id);
      this.lookupservice
        .getLookupbyCode("Security", "RowAccess", RowAccessKind.Branch)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (x) => {
            this.dialogService
              .open(
                action.Form_Component,
                {
                  SelectedRows: ids,
                  RowKindId: x.Id,
                },
                {
                  autoFocus: true,
                  closeOnClickOutside: false,
                }
              )
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe((model: GridFilter[]) => {});
          },
          (error) => {}
        );
    }
  }
}
